module.exports = __webpack_public_path__ + "media/img/illustrations/lost-4799c96fc30525cbddb6e101c519ee87.svg";